import { Container } from "react-bootstrap";
import SideNavbar from "../../../components/navbar/sideNavbar/SideNavbar";
import BottomNavbar from "../../../components/navbar/bottomNavbar/BottomNavbar";
import TopNavbar from "../../../components/navbar/topNavbar/TopNavbar";
import Footer from "../../../components/footer/Footer";
import { Outlet } from "react-router";
import CustomSpinner from "../../../components/spinner/CustomSpinner";
import { useAppDispatch, useTypedSelector } from "../../../app/store";
import { selectShowSpinner } from "../../../app/slices/spinnerSlice";
import CommonAlert from "../../../features/alerts/commonAlert/CommonAlert";
import { clearAlerts } from "../../../features/alerts/commonAlert/commonAlertSlice";
import { useEffect } from "react";
import { useMediaQuery } from "../../../hooks/useMediaQuery";
import { useAuth } from "../../../hooks/useAuth";
import "./RootLayout.scss";

const RootLayout = () => {
    const isShowSpinner = useTypedSelector(selectShowSpinner);
    const isMobile = useMediaQuery("(max-width: 575px)");
    const { isAuthenticated } = useAuth();
    const hasBottomNav = isMobile && isAuthenticated;
    const dispatch = useAppDispatch();

    useEffect(() => {
        return () => {
            dispatch(clearAlerts());
        };
    }, [dispatch]);

    return (
        <div className={`root-layout-wrapper${hasBottomNav ? " has-bottom-nav" : ""}`}>
            {isShowSpinner ? <CustomSpinner isFullScreen={true} /> : undefined}
            <TopNavbar />
            <Container fluid className="p-0 d-flex main-context">
                <main className="order-1 w-100">
                    <Container>
                        <CommonAlert />
                    </Container>
                    <Container className="root-layout-flow-container mt-4">
                        <Outlet />
                    </Container>
                    <Footer />
                </main>
                {isMobile ? <BottomNavbar /> : <SideNavbar />}
            </Container>
        </div>
    );
};

export default RootLayout;
